export default "__VITE_ASSET__DInb8tMt__"